import { render, staticRenderFns } from "./selectBridge.vue?vue&type=template&id=0da805b6&scoped=true"
import script from "./selectBridge.vue?vue&type=script&lang=js"
export * from "./selectBridge.vue?vue&type=script&lang=js"
import style0 from "./selectBridge.vue?vue&type=style&index=0&id=0da805b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da805b6",
  null
  
)

export default component.exports